import React from 'react'

const CurrentDate = () => {
    async function fetchDateTime(retryCount = 0) {
        try{
            const response = await fetch('https://api.timezonedb.com/v2.1/get-time-zone?key=SAXDO13F3L53&format=json&by=zone&zone=Europe/Berlin')
            const data = await response.json();
            // if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){
            //     dateTimeString = new Date(data.formatted.replace(/-/g, "/"));
            // }else{
            const dateTimeString = new Date(data.formatted);
            const date = new Date();
            //}                    

            if(dateTimeString == 'Invalid Date') {
                if(retryCount < 3){
                    fetchDateTime(retryCount + 1);
                }else{
                    localStorage.setItem('date', date);
                }
            }else{
                localStorage.setItem('date', dateTimeString);
            }
        }catch(error){
            fetchDateTime()
        }
    }
    fetchDateTime()
}

export default CurrentDate